// // // import React, { useEffect, useState } from "react";
// // // import { Link } from "react-router-dom";
// // // import "../Categorys/categorys.scss";
// // // import axios from "axios";
// // // import { AiFillEye } from "react-icons/ai";
// // // import { AiFillDelete } from "react-icons/ai";
// // // import { FiEdit } from "react-icons/fi";
// // // import { BsToggleOn, BsToggleOff } from "react-icons/bs";
// // // import Dropdown from "react-bootstrap/Dropdown";
// // // import DropdownButton from "react-bootstrap/DropdownButton";
// // // import { API_BASE_URL } from "../../../utils/index";
// // // import Swal from "sweetalert2/dist/sweetalert2.js";
// // // import { useAuthHeaders } from "../../../components/Token";
// // // import Lottie from "lottie-react";
// // // import Preloader from "../../../Preloader/Preloader-Animation.json";


// // // function ViewDescriptionNameTypes() {
// // //   const [data, setData] = useState([]);
// // //   const headers = useAuthHeaders();
// // //   const [loading, setLoading] = useState(true);



// // //   // useEffect(() => {
// // //   //   try{setLoading(true)

// // //   //   axios
// // //   //     .get(`${API_BASE_URL}/admin/getdescriptiontypes`)
// // //   //     .then((response) => {
// // //   //       setData(response.data?.descriptiontypes);
// // //   //     })
// // //   //     .catch((error) => {
// // //   //       console.error("Error fetching data:", error);
// // //   //     });
// // //   //   }finally{setLoading(false)}
// // //   // }, []);
// // //   useEffect(() => {
// // //     const fetchData = async () => {
// // //       try {
// // //         setLoading(true);
// // //         const response = await axios.get(`${API_BASE_URL}/admin/getdescriptiontypes`);
// // //         setData(response.data?.descriptiontypes);
// // //       } catch (error) {
// // //         console.error("Error fetching data:", error);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };

// // //     fetchData();
// // //   }, []);


// // //   const deleteCategory = (categoryId) => {
// // //     Swal.fire({
// // //       title: "Are you sure?",
// // //       text: "Are you sure you want to delete this Description Name Type?",
// // //       icon: "warning",
// // //       showCancelButton: true,
// // //       confirmButtonColor: "#3085d6",
// // //       cancelButtonColor: "#d33",
// // //       confirmButtonText: "Yes, delete it!",
// // //     }).then((result) => {
// // //       if (result.isConfirmed) {
// // //         axios
// // //           .delete(`${API_BASE_URL}/admin/deletedescriptiontype/${categoryId}`, {
// // //             headers,
// // //           })
// // //           .then(() => {
// // //             setData((prevData) =>
// // //               prevData.filter((item) => item?._id !== categoryId)
// // //             );
// // //           })
// // //           .catch((error) => {
// // //             console.error("Error deleting category:", error);

// // //             Swal.fire({
// // //               icon: "error",
// // //               title: "Oops...",
// // //               text: error.response.data.error,
// // //             });
// // //           });
// // //         Swal.fire({
// // //           title: "Deleted!",
// // //           text: "Your file has been deleted.",
// // //           icon: "success",
// // //         });
// // //       }
// // //     });
// // //   };

// // //   const toggleCategoryStatus = (categoryId, isActive) => {
// // //     // console.log("categoryId", categoryId)
// // //     axios
// // //       .put(
// // //         `${API_BASE_URL}/admin/status/${categoryId}`,
// // //         {
// // //           isActive: !isActive, // Toggle the active status
// // //         },
// // //         {
// // //           headers,
// // //         }
// // //       )
// // //       .then(() => {
// // //         setData((prevData) =>
// // //           prevData.map((item) =>
// // //             item?._id === categoryId ? { ...item, isActive: !isActive } : item
// // //           )
// // //         );
// // //       })
// // //       .catch((error) => {
// // //         console.error("Error toggling category status:", error);

// // //         Swal.fire({
// // //           icon: "error",
// // //           title: "Oops...",
// // //           text: error.response.data.error,
// // //         });
// // //       });
// // //   };

// // //   return (
// // //     <div className="p-4">
// // //       <div className="d-flex justify-content-between my-2">
// // //         <h2 className="m-0">Description Name Types</h2>
// // //         <Link to="/createDescriptionNameTypes" className="btn btn-primary">
// // //           Add New
// // //         </Link>
// // //       </div>
// // //       <table className="categorys-table" style={{boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset"}}>
// // //         <thead>
// // //           <tr>
// // //             <th>Name</th>
// // //             <th>NameTypes</th>
// // //             <th>Sub Category</th>
// // //             <th>Category</th>
// // //             <th>Action</th>
// // //           </tr>
// // //         </thead>
// // //         <tbody>
// // //         {loading ? (
// // //         <Lottie
// // //           style={{ width: "100vw", height: "50vh" }}
// // //           animationData={Preloader}
// // //         />
// // //       ) : (<>
// // //           {data.map((item, index) => (
// // //             <tr key={index}>
// // //               <td>{item.descriptionname?.descriptionName}</td>
// // //               <td>
// // //                 <DropdownButton id="dropdown-item-button" title="i">
// // //                   {item?.descriptionnametypes.map((innerItem, i) => {
// // //                     // console.log("item dropdown :", innerItem);
// // //                     return (
// // //                       <Dropdown.Item key={i} as="button">
// // //                         {innerItem}
// // //                       </Dropdown.Item>
// // //                     );
// // //                   })}
// // //                 </DropdownButton>
// // //               </td>
// // //               <td> {item?.subcategory?.name} </td>
// // //               <td> {item?.category?.name} </td>
// // //               <td>
// // //                 <Link to={`/descriptionNameTypesDetial/${item?._id}`}>
// // //                   <button className="mx-1">
// // //                     <AiFillEye className="m-2 fs-6" />
// // //                   </button>
// // //                 </Link>

// // //                 <button
// // //                   className="mx-1"
// // //                   onClick={() => deleteCategory(item?._id)}
// // //                 >
// // //                   <AiFillDelete className="m-2 fs-6" />
// // //                 </button>

// // //                 <Link to={`/editDescriptionNameTypesDetial/${item?._id}`}>
// // //                   <button className="mx-1">
// // //                     <FiEdit className="m-2 fs-6" />
// // //                   </button>
// // //                 </Link>

// // //                 <button
// // //                   className="mx-1"
// // //                   onClick={() => toggleCategoryStatus(item?._id, item?.isActive)}
// // //                 >
// // //                   {item?.isActive ? (
// // //                     <BsToggleOn className="m-2 fs-6" />
// // //                   ) : (
// // //                     <BsToggleOff className="m-2 fs-6" />
// // //                   )}
// // //                 </button>
// // //               </td>
// // //             </tr>
// // //           ))}
// // //           </>)}
// // //         </tbody>
// // //       </table>
// // //     </div>
// // //   );
// // // }

// // // export default ViewDescriptionNameTypes;
// // // import React, { useEffect, useState } from "react";
// // // import { Link } from "react-router-dom";
// // // import {
// // //   Box,
// // //   Typography,
// // //   IconButton,
// // //   Tooltip,
// // //   Snackbar,
// // //   Alert,
// // //   Button,
// // // } from "@mui/material";
// // // import { DataGrid } from "@mui/x-data-grid";
// // // import { AiFillEye, AiFillDelete } from "react-icons/ai";
// // // import { FiEdit } from "react-icons/fi";
// // // import { BsToggleOn, BsToggleOff } from "react-icons/bs";
// // // import Swal from "sweetalert2";
// // // import { useAuthHeaders } from "../../../../components/Token";

// // // import Lottie from "lottie-react";
// // // import Preloader from "../../../../Preloader/Preloader-Animation.json";
// // // import { DELETEDESvendor, UpdatestatusVendorDES } from "../../../../services/api/Descriptions";
// // // import { GetVendordescriptionsTYPe } from "../../../../services/api/DescriptionType";

// // // const ViewDescriptionNameTypesVendor = () => {
// // //   const [data, setData] = useState([]);
// // //   const headers = useAuthHeaders();
// // //   const [loading, setLoading] = useState(true);
// // //   const subdomain = localStorage.getItem("vendorsubdomain");
// // //   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

// // //   useEffect(() => {
// // //     const fetchData = async () => {
// // //       try {
// // //         setLoading(true);
// // //         const response = await GetVendordescriptionsTYPe(subdomain);
// // //         setData(response?.descriptiontypes || []);
// // //       } catch (error) {
// // //         console.error("Error fetching data:", error);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };

// // //     fetchData();
// // //   }, []);

// // //   const handleDelete = async (id) => {
// // //     Swal.fire({
// // //       title: "Are you sure?",
// // //       text: "Do you really want to delete this Description?",
// // //       icon: "warning",
// // //       showCancelButton: true,
// // //       confirmButtonColor: "#d33",
// // //       cancelButtonColor: "#aaa",
// // //       confirmButtonText: "Yes, delete it!",
// // //     }).then(async (result) => {
// // //       if (result.isConfirmed) {
// // //         try {
// // //           await DELETEDESvendor(subdomain, id);
// // //           setData((prev) => prev.filter((item) => item._id !== id));
// // //           setSnackbar({ open: true, message: "Deleted successfully", severity: "success" });
// // //         } catch (error) {
// // //           console.error("Error deleting:", error);
// // //           setSnackbar({ open: true, message: error?.message || "Delete failed", severity: "error" });
// // //         }
// // //       }
// // //     });
// // //   };

// // //   const toggleStatus = async (id, currentStatus) => {
// // //     try {
// // //       await UpdatestatusVendorDES(subdomain, { isActive: !currentStatus }, id);
// // //       setData((prev) =>
// // //         prev.map((item) => (item._id === id ? { ...item, isActive: !currentStatus } : item))
// // //       );
// // //       setSnackbar({ open: true, message: "Status updated", severity: "success" });
// // //     } catch (error) {
// // //       setSnackbar({ open: true, message: error?.message || "Update failed", severity: "error" });
// // //     }
// // //   };

// // //   const columns = [
// // //     { field: "descriptionName", headerName: "Name", flex: 1 },
// // //     {
// // //       field: "category",
// // //       headerName: "Category",
// // //       flex: 1,
// // //       valueGetter: (params) => params.row.category?.name || "-",
// // //     },
// // //     {
// // //       field: "subcategory",
// // //       headerName: "Sub Category",
// // //       flex: 1,
// // //       valueGetter: (params) => params.row.subcategory?.name || "-",
// // //     },
// // //     {
// // //       field: "actions",
// // //       headerName: "Actions",
// // //       flex: 1.2,
// // //       sortable: false,
// // //       renderCell: (params) => {
// // //         const row = params.row;
// // //         return (
// // //           <Box display="flex" alignItems="center">
// // //             <Tooltip title="View">
// // //               {/* <IconButton component={Link} to={`/descriptionNameTypesDetial/${row._id}`}>
// // //                 <AiFillEye />
// // //               </IconButton> */}
// // //             </Tooltip>
// // //             <Tooltip title="Delete">
// // //               <IconButton onClick={() => handleDelete(row._id)}>
// // //                 <AiFillDelete />
// // //               </IconButton>
// // //             </Tooltip>
// // //             <Tooltip title="Edit">
// // //               {/* <IconButton component={Link} to={`//${row._id}`}> */}
// // //               <IconButton component={Link} to={`/${subdomain}/master/description-type/edit/${row._id}`}>
// // //                 <FiEdit />
// // //               </IconButton>
// // //             </Tooltip>
// // //             <Tooltip title={row.isActive ? "Deactivate" : "Activate"}>
// // //               <IconButton onClick={() => toggleStatus(row._id, row.isActive)}>
// // //                 {row.isActive ? <BsToggleOn color="green" /> : <BsToggleOff color="gray" />}
// // //               </IconButton>
// // //             </Tooltip>
// // //           </Box>
// // //         );
// // //       },
// // //     },
// // //   ];

// // //   return (
// // //     <Box p={3}>
// // //       <Box display="flex" justifyContent="space-between" mb={2}>
// // //         <Typography variant="h5">Description Name Types</Typography>
// // //         <Button component={Link} to={`/${subdomain}/master/description-type/create`} variant="contained" color="primary">
// // //           Add New
// // //         </Button>
// // //       </Box>

// // //       {loading ? (
// // //         <Box height="50vh" display="flex" justifyContent="center" alignItems="center">
// // //           <Lottie animationData={Preloader} style={{ width: 300 }} />
// // //         </Box>
// // //       ) : (
// // //         <DataGrid
// // //           rows={data}
// // //           columns={columns}
// // //           getRowId={(row) => row._id}
// // //           autoHeight
// // //           disableRowSelectionOnClick
// // //           sx={{
// // //             boxShadow: 3,
// // //             borderRadius: 2,
// // //             border: "1px solid #ccc",
// // //           }}
// // //         />
// // //       )}

// // //       <Snackbar
// // //         open={snackbar.open}
// // //         autoHideDuration={3000}
// // //         onClose={() => setSnackbar({ ...snackbar, open: false })}
// // //       >
// // //         <Alert
// // //           onClose={() => setSnackbar({ ...snackbar, open: false })}
// // //           severity={snackbar.severity}
// // //           sx={{ width: "100%" }}
// // //         >
// // //           {snackbar.message}
// // //         </Alert>
// // //       </Snackbar>
// // //     </Box>
// // //   );
// // // };

// // // export default ViewDescriptionNameTypesVendor;


// // import React, { useEffect, useState } from "react";
// // import {
// //   Box,
// //   Typography,
// //   IconButton,
// //   Tooltip,
// //   Snackbar,
// //   Alert,
// //   Button,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogContentText,
// //   DialogActions,
// // } from "@mui/material";
// // import { DataGrid } from "@mui/x-data-grid";
// // import { AiFillEye, AiFillDelete } from "react-icons/ai";
// // import { FiEdit } from "react-icons/fi";
// // import { BsToggleOn, BsToggleOff } from "react-icons/bs";
// // import { Link } from "react-router-dom";
// // import Lottie from "lottie-react";
// // import axios from "axios";

// // import Preloader from "../../../../Preloader/Preloader-Animation.json";
// // import { API_BASE_URL } from "../../../../utils/index";
// // import { useAuthHeaders } from "../../../../components/Token";
// // import { GetVendordescriptionsTYPe } from "../../../../services/api/DescriptionType";

// // const ViewDescriptionNameTypes = () => {
// //   const [data, setData] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
// //   const [confirmDialog, setConfirmDialog] = useState({ open: false, id: null });
// //   const headers = useAuthHeaders();
// //   const slugname = localStorage.getItem("vendorsubdomain");

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         setLoading(true);
// //         // const response = await axios.get(`${API_BASE_URL}/admin/getdescriptiontypes`);
// //         const repsonse = await GetVendordescriptionsTYPe(slugname)
// //         if (repsonse) {

// //           setData(repsonse?.descriptiontypes || []);
// //         }
// //       } catch (error) {
// //         console.error("Error fetching data:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchData();
// //   }, []);

// //   const handleDelete = async (id) => {
// //     try {
// //       await axios.delete(`${API_BASE_URL}/admin/deletedescriptiontype/${id}`, { headers });
// //       setData((prev) => prev.filter((item) => item._id !== id));
// //       setSnackbar({ open: true, message: "Deleted successfully", severity: "success" });
// //     } catch (error) {
// //       setSnackbar({ open: true, message: error?.response?.data?.error || "Delete failed", severity: "error" });
// //     } finally {
// //       setConfirmDialog({ open: false, id: null });
// //     }
// //   };

// //   const toggleStatus = async (id, currentStatus) => {
// //     try {
// //       await axios.put(
// //         `${API_BASE_URL}/admin/status/${id}`,
// //         { isActive: !currentStatus },
// //         { headers }
// //       );
// //       setData((prev) =>
// //         prev.map((item) => (item._id === id ? { ...item, isActive: !currentStatus } : item))
// //       );
// //       setSnackbar({ open: true, message: "Status updated", severity: "success" });
// //     } catch (error) {
// //       setSnackbar({ open: true, message: error?.response?.data?.error || "Update failed", severity: "error" });
// //     }
// //   };

// //   const columns = [
// //     {
// //       field: "descriptionName",
// //       headerName: "Name",
// //       flex: 1,
// //       valueGetter: (params) => params.row.descriptionname?.descriptionName || "-",
// //     },
// //     {
// //       field: "descriptionnametypes",
// //       headerName: "Name Types",
// //       flex: 1.5,
// //       renderCell: (params) => {
// //         const types = params.row.descriptionnametypes || [];

// //         return (
// //           <Box
// //             sx={{
// //               border: "1px solid #ccc",
// //               borderRadius: 1,
// //               px: 1,
// //               py: 0.5,
// //               width: "100%",
// //               backgroundColor: "#f9f9f9",
// //               maxHeight: 90,
// //               overflowY: "auto",
// //             }}
// //           >
// //             <Typography variant="body2" color="textSecondary" fontWeight="bold" mb={0.5}>
// //               {types.length > 0 ? "Types:" : "-"}
// //             </Typography>
// //             {types.map((type, i) => (
// //               <Typography key={i} variant="body2" sx={{ ml: 1 }}>
// //                 • {type}
// //               </Typography>
// //             ))}
// //           </Box>
// //         );

// //         // Optional tooltip version:
// //         /*
// //         return (
// //           <Tooltip
// //             title={
// //               <Box>
// //                 {types.map((type, i) => (
// //                   <Typography key={i} variant="body2">• {type}</Typography>
// //                 ))}
// //               </Box>
// //             }
// //             arrow
// //             placement="top"
// //           >
// //             <Typography sx={{ cursor: "pointer", color: "#0443c0" }}>
// //               {types.length} Type{types.length !== 1 ? "s" : ""}
// //             </Typography>
// //           </Tooltip>
// //         );
// //         */
// //       },
// //     },
// //     {
// //       field: "subcategory",
// //       headerName: "Sub Category",
// //       flex: 1,
// //       valueGetter: (params) => params.row.subcategory?.name || "-",
// //     },
// //     {
// //       field: "category",
// //       headerName: "Category",
// //       flex: 1,
// //       valueGetter: (params) => params.row.category?.name || "-",
// //     },
// //     {
// //       field: "actions",
// //       headerName: "Actions",
// //       flex: 1.2,
// //       sortable: false,
// //       renderCell: (params) => {
// //         const row = params.row;
// //         return (
// //           <Box display="flex" gap={1}>
// //             <Tooltip title="View">
// //               <IconButton component={Link} to={`/descriptionNameTypesDetial/${row._id}`}>
// //                 <AiFillEye />
// //               </IconButton>
// //             </Tooltip>
// //             <Tooltip title="Edit">
// //               <IconButton component={Link} to={`/editDescriptionNameTypesDetial/${row._id}`}>
// //                 <FiEdit />
// //               </IconButton>
// //             </Tooltip>
// //             <Tooltip title="Delete">
// //               <IconButton onClick={() => setConfirmDialog({ open: true, id: row._id })}>
// //                 <AiFillDelete />
// //               </IconButton>
// //             </Tooltip>
// //             <Tooltip title={row.isActive ? "Deactivate" : "Activate"}>
// //               <IconButton onClick={() => toggleStatus(row._id, row.isActive)}>
// //                 {row.isActive ? <BsToggleOn color="green" /> : <BsToggleOff color="gray" />}
// //               </IconButton>
// //             </Tooltip>
// //           </Box>
// //         );
// //       },
// //     },
// //   ];

// //   return (
// //     <Box p={3}>
// //       <Box display="flex" justifyContent="space-between" mb={2}>
// //         <Typography variant="h5">Description Name Types</Typography>
// //         <Button variant="contained" component={Link} to="/createDescriptionNameTypes">
// //           Add New
// //         </Button>
// //       </Box>

// //       {loading ? (
// //         <Box height="50vh" display="flex" justifyContent="center" alignItems="center">
// //           <Lottie animationData={Preloader} style={{ width: 300 }} />
// //         </Box>
// //       ) : (
// //         <DataGrid
// //           rows={data}
// //           columns={columns}
// //           getRowId={(row) => row._id}
// //           autoHeight
// //           disableRowSelectionOnClick
// //           sx={{
// //             boxShadow: 3,
// //             borderRadius: 2,
// //             border: "1px solid #ccc",
// //           }}
// //         />
// //       )}

// //       {/* Delete Confirmation Dialog */}
// //       <Dialog
// //         open={confirmDialog.open}
// //         onClose={() => setConfirmDialog({ open: false, id: null })}
// //       >
// //         <DialogTitle>Confirm Delete</DialogTitle>
// //         <DialogContent>
// //           <DialogContentText>
// //             Are you sure you want to delete this Description Name Type?
// //           </DialogContentText>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setConfirmDialog({ open: false, id: null })}>
// //             Cancel
// //           </Button>
// //           <Button color="error" onClick={() => handleDelete(confirmDialog.id)}>
// //             Delete
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       {/* Snackbar */}
// //       <Snackbar
// //         open={snackbar.open}
// //         autoHideDuration={3000}
// //         onClose={() => setSnackbar({ ...snackbar, open: false })}
// //       >
// //         <Alert
// //           onClose={() => setSnackbar({ ...snackbar, open: false })}
// //           severity={snackbar.severity}
// //           sx={{ width: "100%" }}
// //         >
// //           {snackbar.message}
// //         </Alert>
// //       </Snackbar>
// //     </Box>
// //   );
// // };

// // export default ViewDescriptionNameTypes;
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   IconButton,
//   Tooltip,
//   Snackbar,
//   Alert,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { AiFillEye, AiFillDelete } from "react-icons/ai";
// import { FiEdit } from "react-icons/fi";
// import { BsToggleOn, BsToggleOff } from "react-icons/bs";
// import { Link } from "react-router-dom";
// import Lottie from "lottie-react";

// import Preloader from "../../../../Preloader/Preloader-Animation.json";
// import { useAuthHeaders } from "../../../../components/Token";
// import {
//   GetVendordescriptionsTYPe,
//   DELETEDESvendorTYPe,
//   UpdatestatusVendorDESTYPe,
// } from "../../../../services/api/DescriptionType";

// const ViewDescriptionNameTypes = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//   const [confirmDialog, setConfirmDialog] = useState({ open: false, id: null });
//   const slugname = localStorage.getItem("vendorsubdomain");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const response = await GetVendordescriptionsTYPe(slugname);
//         setData(response?.descriptiontypes || []);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [slugname]);

//   const handleDelete = async (id) => {
//     try {
//       await DELETEDESvendorTYPe(slugname, id);
//       setData((prev) => prev.filter((item) => item._id !== id));
//       setSnackbar({ open: true, message: "Deleted successfully", severity: "success" });
//     } catch (error) {
//       setSnackbar({ open: true, message: "Delete failed", severity: "error" });
//     } finally {
//       setConfirmDialog({ open: false, id: null });
//     }
//   };

//   const toggleStatus = async (id, currentStatus) => {
//     try {
//       await UpdatestatusVendorDESTYPe(slugname, { isActive: !currentStatus }, id);
//       setData((prev) =>
//         prev.map((item) => (item._id === id ? { ...item, isActive: !currentStatus } : item))
//       );
//       setSnackbar({ open: true, message: "Status updated", severity: "success" });
//     } catch (error) {
//       setSnackbar({ open: true, message: "Status update failed", severity: "error" });
//     }
//   };

//   const columns = [
//     {
//       field: "descriptionName",
//       headerName: "Name",
//       flex: 1,
//       valueGetter: (params) => params.row.descriptionname?.descriptionName || "-",
//     },
//     {
//       field: "descriptionnametypes",
//       headerName: "Name Types",
//       flex: 1.5,
//       renderCell: (params) => {
//         const types = params.row.descriptionnametypes || [];
//         return (
//           <Box
//             sx={{
//               border: "1px solid #ccc",
//               borderRadius: 1,
//               px: 1,
//               py: 0.5,
//               width: "100%",
//               backgroundColor: "#f9f9f9",
//               maxHeight: 90,
//               overflowY: "auto",
//             }}
//           >
//             <Typography variant="body2" color="textSecondary" fontWeight="bold" mb={0.5}>
//               {types.length > 0 ? "Types:" : "-"}
//             </Typography>
//             {types.map((type, i) => (
//               <Typography key={i} variant="body2" sx={{ ml: 1 }}>
//                 • {type}
//               </Typography>
//             ))}
//           </Box>
//         );
//       },
//     },
//     {
//       field: "subcategory",
//       headerName: "Sub Category",
//       flex: 1,
//       valueGetter: (params) => params.row.subcategory?.name || "-",
//     },
//     {
//       field: "category",
//       headerName: "Category",
//       flex: 1,
//       valueGetter: (params) => params.row.category?.name || "-",
//     },
//     {
//       field: "actions",
//       headerName: "Actions",
//       flex: 1.2,
//       sortable: false,
//       renderCell: (params) => {
//         const row = params.row;
//         return (
//           <Box display="flex" gap={1}>
//             <Tooltip title="View">
//               <IconButton component={Link} to={`/descriptionNameTypesDetial/${row._id}`}>
//                 <AiFillEye />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Edit">
//               <IconButton component={Link} to={`/editDescriptionNameTypesDetial/${row._id}`}>
//                 <FiEdit />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Delete">
//               <IconButton onClick={() => setConfirmDialog({ open: true, id: row._id })}>
//                 <AiFillDelete />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title={row.isActive ? "Deactivate" : "Activate"}>
//               <IconButton onClick={() => toggleStatus(row._id, row.isActive)}>
//                 {row.isActive ? <BsToggleOn color="green" /> : <BsToggleOff color="gray" />}
//               </IconButton>
//             </Tooltip>
//           </Box>
//         );
//       },
//     },
//   ];

//   return (
//     <Box p={3}>
//       <Box display="flex" justifyContent="space-between" mb={2}>
//         <Typography variant="h5">Description Name Types</Typography>
//         <Button variant="contained" component={Link} to="/createDescriptionNameTypes">
//           Add New
//         </Button>
//       </Box>

//       {loading ? (
//         <Box height="50vh" display="flex" justifyContent="center" alignItems="center">
//           <Lottie animationData={Preloader} style={{ width: 300 }} />
//         </Box>
//       ) : (
//         <DataGrid
//           rows={data}
//           columns={columns}
//           getRowId={(row) => row._id}
//           autoHeight
//           disableRowSelectionOnClick
//           sx={{
//             boxShadow: 3,
//             borderRadius: 2,
//             border: "1px solid #ccc",
//           }}
//         />
//       )}

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={confirmDialog.open}
//         onClose={() => setConfirmDialog({ open: false, id: null })}
//       >
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete this Description Name Type?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setConfirmDialog({ open: false, id: null })}>
//             Cancel
//           </Button>
//           <Button color="error" onClick={() => handleDelete(confirmDialog.id)}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//       >
//         <Alert
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           severity={snackbar.severity}
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default ViewDescriptionNameTypes;


import React, { useContext, useEffect, useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Snackbar,
  Alert,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Select,
  MenuItem,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { AiFillEye, AiFillDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";

import Preloader from "../../../../Preloader/Preloader-Animation.json";
import { useAuthHeaders } from "../../../../components/Token";
import {
  GetVendordescriptionsTYPe,
  DELETEDESvendorTYPe,
  UpdatestatusVendorDESTYPe,
} from "../../../../services/api/DescriptionType";
import userContext from "../../../../components/UseContext/UseContext";

const ViewDescriptionNameTypes = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [confirmDialog, setConfirmDialog] = useState({ open: false, id: null });
  const slugname = localStorage.getItem("vendorsubdomain");
  const { permissionvalues } = useContext(userContext);
  const
    permissions = permissionvalues?.permissions?.master?.descriptionType
  console.log(permissions, "permissions")
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await GetVendordescriptionsTYPe(slugname);
        setData(response?.descriptiontypes || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [slugname]);

  const handleDelete = async (id) => {
    try {
      const response = await DELETEDESvendorTYPe(slugname, id);

      if (response.success) {

        setSnackbar({ open: true, message: response.message, severity: "success" });
        setData((prev) => prev.filter((item) => item._id !== id));
      } else {
        setSnackbar({ open: true, message: response.message, severity: "error" });
      }
    } catch (error) {
      setSnackbar({ open: true, message: "Delete failed", severity: "error" });
    } finally {
      setConfirmDialog({ open: false, id: null });
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const respone = await UpdatestatusVendorDESTYPe(slugname, { isActive: !currentStatus }, id);

      if (respone.success) {

        setData((prev) =>
          prev.map((item) => (item._id === id ? { ...item, isActive: !currentStatus } : item))
        );
        setSnackbar({ open: true, message: respone.message, severity: "success" });
      } else {

        setSnackbar({ open: true, message: respone.message, severity: "error" });
      }
    } catch (error) {
      setSnackbar({ open: true, message: "Status update failed", severity: "error" });
    }
  };

  const columns = [
    {
      field: "descriptionName",
      headerName: "Name",
      flex: 1,
      valueGetter: (params) => params.row.descriptionname?.descriptionName || "-",
    },
    {
      field: "descriptionnametypes",
      headerName: "Name Types",
      flex: 1.5,
      renderCell: (params) => {
        const types = params.row.descriptionnametypes || [];

        return (
          <Box
            sx={{
              backgroundColor: "#f9f9f9",
              borderRadius: 1,
              px: 1,
              py: 2,
              border: "1px solid #ddd",
              maxHeight: 50,
              overflowY: "auto",
              width: "100%",

            }}
          >
            {types.length > 0 ? (
              types.map((type, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  sx={{ fontSize: "0.85rem", color: "#333", }}
                >
                  • {type}
                </Typography>
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                -
              </Typography>
            )}
          </Box>
        );
      },
    },

    {
      field: "subcategory",
      headerName: "Sub Category",
      flex: 1,
      valueGetter: (params) => params.row.subcategory?.name || "-",
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
      valueGetter: (params) => params.row.category?.name || "-",
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1.2,
      sortable: false,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" gap={1}>
            {/* <Tooltip title="View">
              <IconButton component={Link} to={`/descriptionNameTypesDetial/${row._id}`}>
                <AiFillEye />
              </IconButton>
            </Tooltip> */}
            {permissions.edit && row.vendor &&
              <Tooltip title="Edit">
                <IconButton component={Link} to={`/${slugname}/master/description-type/edit/${row._id}`}>
                  <EditIcon fontSize="small" sx={{ color: "secondary" }} />
                </IconButton>
              </Tooltip>
            }
            {permissions.delete && row.vendor &&
              <Tooltip title="Delete">
                <IconButton color="error" onClick={() => setConfirmDialog({ open: true, id: row._id })}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            }
            {permissions.edit && row.vendor &&
              <Tooltip title={row.isActive ? "Deactivate" : "Activate"}>
                <IconButton onClick={() => toggleStatus(row._id, row.isActive)}>
                  {row.isActive ? <BsToggleOn color="green" /> : <BsToggleOff color="gray" />}
                </IconButton>
              </Tooltip>
            }
          </Box>
        );
      },
    },
  ];

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h5">Description Name Types</Typography>

        {permissions?.create &&
          <Button variant="contained" component={Link} to={`/${slugname}/master/description-type/create`}>
            Add New
          </Button>
        }
      </Box>

      {loading ? (
        <Box height="50vh" display="flex" justifyContent="center" alignItems="center">
          <Lottie animationData={Preloader} style={{ width: 300 }} />
        </Box>
      ) : (
        <DataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row._id}
          autoHeight
          disableRowSelectionOnClick
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            border: "1px solid #ccc",
          }}
        />
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, id: null })}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this Description Name Type?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialog({ open: false, id: null })}>
            Cancel
          </Button>
          <Button color="error" onClick={() => handleDelete(confirmDialog.id)}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ViewDescriptionNameTypes;
